<template>
  <div class="contact-page">
    <header>
      <div class="normal-header-block">
        <div class="container">
          <div class="slogan-container">
            <h1>和鲸是值得信赖的合作伙伴</h1>
          </div>
        </div>
      </div>
    </header>
    <section>
      <div class="bg-block bg-location">
        <div class="location-container container">
          <div class="location-flex-wrapper">
            <div class="location-loc-card">
              <div class="location-map-container" id="map-shanghai-loc">
              </div>
              <div class="location-loc-detail">
                <h3>上海</h3>
                <h4>上海市虹桥路333号慧谷高科技创业中心</h4>
              </div>
            </div>
            <div class="location-loc-card">
              <div class="location-map-container" id="map-beijing-loc">
              </div>
              <div class="location-loc-detail">
                <h3>北京</h3>
                <h4>北京市朝阳区东直门外斜街56号文创园</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-block bg-contact">
        <div class="contact-container container">
          <div class="contact-flex-wrapper">
            <div class="contact-card">
              <div>
                <h3>商务合作</h3>
                <p><span class="iconfont icon-phone"></span><a href="tel:021-80370235">021-8037 0235（转008）</a></p>
                <p><span class="iconfont icon-mail"></span><a href="mailto:business@heywhale.com">business@heywhale.com</a></p>
              </div>
            </div>
            <div class="contact-card">
              <div>
                <h3>媒介合作</h3>
                <p><span class="iconfont icon-phone"></span><a href="tel:021-80370235">021-8037 0235（转096）</a></p>
                <p><span class="iconfont icon-mail"></span><a href="mailto:pr@heywhale.com">pr@heywhale.com</a></p>
              </div>
            </div>
            <div class="contact-card">
              <p>扫码二维码<br/>关注微信服务号<br/>和鲸HeyWhale<br/>了解更多公司信息</p>
              <img class="qrcode" src="../assets/qrcode-hey-whale.png">
            </div>
          </div>
          <div class="contact-banner">
            <h2>欢迎预约</h2>
            <h4>数据智能时代的商业模式变革专题报告会</h4>
          </div>
        </div>
      </div>
      <div class="bg-block bg-qrcode">
        <div class="qrcode-container container">
          <div class="qrcode-flex-container">
            <div class="qrcode-card">
              <img src="../assets/qrcode-kesci.png">
              <h5>扫描二维码 <br/><span class="bold-text">关注公众号  科赛kesci</span><br/>了解更多社区信息</h5>
            </div>
            <div class="qrcode-card">
              <img src="../assets/qrcode-business.png">
              <h5>扫描二维码<br/><span class="bold-text">关注公众号  数据商业家</span><br/>了解更多行业动态</h5>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
const BMap = window.BMap;
export default {
  beforeRouteEnter(from, to, next) {
    next((vm) => {
      vm.initBMap();
    });
  },
  beforeRouteLeave(from, to, next) {
    this.destoryBMap();
    next();
  },
  methods: {
    initBMap() {
      const shLoc = document.querySelector('#map-shanghai-loc');
      const bjLoc = document.querySelector('#map-beijing-loc');
      const shMap = new BMap.Map(shLoc);
      const bjMap = new BMap.Map(bjLoc);
      const shPoint = new BMap.Point(121.438, 31.199);
      const bjPoint = new BMap.Point(116.451, 39.953);
      shMap.centerAndZoom(shPoint, 15);
      shMap.enableScrollWheelZoom(true);
      bjMap.centerAndZoom(bjPoint, 15);
      bjMap.enableScrollWheelZoom(true);
      const shMarker = new BMap.Marker(shPoint);
      shMap.addOverlay(shMarker);
      const bjMarker = new BMap.Marker(bjPoint);
      bjMap.addOverlay(bjMarker);
    },
    destoryBMap() {
      // todo
    }
  }
};
</script>

<style lang="scss">
.contact-page {
  .normal-header-block {
    background-image: url("../assets/banners/contact.png");
  }
  .bg-location {
    background-image: url('../assets/bg-location.jpg');
    background-size: cover;
    padding: 80px 0px;
  }
  .bg-contact {
    background-color: #fff;
    padding: 72px 0px;
  }
  .bg-qrcode {
    padding: 80px 0px;
  }
  .location-flex-wrapper {
    display: flex;
    justify-content: space-between;
  }
  .location-loc-card {
    width: 45%;
  }
  .location-map-container {
    height: 300px;
    background-color: #006EFF;
    .BMap_cpyCtrl, .anchorBL {
      display: none;
    }
  }
  .location-loc-detail {
    padding: 20px 60px;
    text-align: center;
    background-color: #fff;
    h3 {
      font-size: 24px;
      font-weight: 500;
    }
    h4 {
      font-size: 18px;
      font-weight: 400;
    }
  }
  .contact-flex-wrapper {
    display: flex;
    justify-content: space-between;
    margin-bottom: 80px;
  }

  .contact-card {
    width: 30%;
    //height: 120px;
    padding: 20px 36px;
    border: solid 1px #006EFF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    .iconfont {
      color: #006EFF;
      margin-right: 12px;
      font-size: 18px;
      line-height: 24px;
      position: relative;
      top: 2px;
    }
    img {
      margin-right: 32px;
    }
    img.qrcode {
      width: 80px;
      height: 80px;
      margin-right: 0px;
      margin-left: 60px;
    }
    h3 {
      font-weight: 500;
      margin-top: 0px;
    }
    h4 {
      margin-top: 0px;
      font-size: 16px;
      font-weight: 400;
    }
    p {
      margin: 0px 0px 4px 0px;
      line-height: 24px;
    }
    a {
      color: #828A92 !important;
    }
  }
  .contact-banner {
    padding: 28px;
    background-image: url('../assets/bg-contact.png');
    background-size: cover;
    h2 {
      margin-top: 0px;
      font-size: 26px;
      color: #fff;
    }
    h4 {
      font-size: 16px;
      color: #fff;
    }
  }
  .qrcode-flex-container {
    display: flex;
    justify-content: center;
  }
  .qrcode-card {
    text-align: center;
    margin: 0px 32px;
    img {
      width: 108px;
      height: 108px;
    }
    h5 {
      font-weight: 400;
      .bold-text {
        font-weight: 700;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contact.vue